import en from "@/lang/en.json";
import pl from "@/lang/pl.json";
import es from "@/lang/es.json";
import de from "@/lang/de.json";
import zh from "@/lang/zh.json";
import fr from "@/lang/fr.json";
import nl from "@/lang/nl.json";
import it from "@/lang/it.json";
import ru from "@/lang/ru.json";
import {
  DEFAULT_LOCALE,
  HIDDEN_LOCALES,
  isHiddenLocale,
  isPublicLocale,
  isSupportedLocale,
  LOCALES,
  PUBLIC_LOCALES,
  type SupportedLocale,
} from "@/lib/localeCatalog";

export type { SupportedLocale };
export {
  DEFAULT_LOCALE,
  HIDDEN_LOCALES,
  isHiddenLocale,
  isPublicLocale,
  isSupportedLocale,
  LOCALES,
  PUBLIC_LOCALES,
};

type Messages = typeof en;
export type MessageKey = keyof Messages;

const messages: Record<SupportedLocale, Messages> = {
  en,
  pl,
  es,
  de,
  zh,
  fr,
  nl,
  it,
  ru,
};

export function normalizeLocale(locale?: string | null | undefined): SupportedLocale {
  if (!locale || locale === "undefined") return "en";
  const short = locale.split("-")[0] as SupportedLocale;
  if (isSupportedLocale(short)) return short;
  return "en";
}

/** Wyciąga locale z ścieżki URL (np. /pl/about-12go → pl). Gdy brak prefiksu, zwraca DEFAULT_LOCALE. */
export function getLocaleFromPath(path: string): SupportedLocale {
  const segments = (path || "/").replace(/^\/+/, "").split("/").filter(Boolean);
  const first = segments[0];
  if (first && isSupportedLocale(first)) return first;
  return DEFAULT_LOCALE;
}

export function t(locale: SupportedLocale, key: MessageKey): string {
  return messages[locale][key] ?? messages.en[key] ?? key;
}

export function tf(
  locale: SupportedLocale,
  key: MessageKey,
  vars: Record<string, string | number>,
): string {
  let out = t(locale, key);
  for (const [name, value] of Object.entries(vars)) {
    out = out.replaceAll(`{${name}}`, String(value));
  }
  return out;
}
